<template>
  <div class="around">
    <div class="around_return" @click="clickReturn">
      <img src="../../assets/img/pc/return.png" alt="" />
    </div>
    <div class="around_content">
      <div
        class="around_content_item"
        v-for="(item, index) in aroundList"
        :key="index"
        @click="aroundClick(item.id)"
      >
        <div class="around_content_item_pic">
          <div class="around_content_item_pic_cover"></div>
          <img
            class="around_content_item_pic_icon"
            src="../../assets/img/pc/icon_pano.png"
            alt=""
          />
          <img :src="item.thumbnail" alt="" />
        </div>
        <div class="around_content_item_title">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['aroundList'],
  methods: {
    clickReturn() {
      this.$emit('return')
    },

    aroundClick(id) {
      this.$emit('setPano', id)
      // console.log(id)
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
.around {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: url('../../assets/img/pc/cover-bg.png') #eee no-repeat center
    center/100% 100%;
  .around_return {
    cursor: pointer;
    width: rem(158);
    height: rem(85);
    position: absolute;
    left: rem(40);
    top: rem(40);
    z-index: 9;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .around_content {
    width: rem(1600);
    height: rem(880);
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url('../../assets/img/pc/cover_content-bg.png') #fff no-repeat
      center center/110% 111%;
    border-radius: 10px;
    padding-left: rem(100);
    padding-top: rem(80);
    box-sizing: border-box;
    &::-webkit-scrollbar-track {
      // background: red;
    }
    &::-webkit-scrollbar-thumb {
      // background: red;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0);
      width: 5px;
      border-radius: 10px;
    }
  }
  .around_content_item {
    cursor: pointer;
    width: rem(450);
    height: rem(325);
    overflow: hidden;
    border-radius: 5px;
    margin-right: rem(25);
    margin-bottom: rem(40);
    border-radius: 8px;
  }
  .around_content_item_pic {
    width: 100%;
    height: rem(254);
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .around_content_item_pic_cover {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 5;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }
    .around_content_item_pic_icon {
      width: rem(50);
      height: rem(50);
      display: block;
      position: absolute;
      z-index: 9;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .around_content_item_title {
    width: 100%;
    height: rem(50);
    line-height: rem(50);
    padding-left: rem(20);
    box-sizing: border-box;
    color: #fff;
    background: rgb(231, 5, 5);
    font-size: rem(20);
    text-align: center;
    border-radius: 0 0 8px 8px;
  }
}
</style>
